import React from 'react';
import { renderIconBySlug } from '../../content/icons';

export const PicSelectionOptions = props => {
  const {
    title = 'Image affichée',
    options = [],
    value = null,
    onChange = null,
    size = 30,
    maxHeight = 220,
    className = '',
    extra = null,
  } = props;

  const handleSelect = key => {
    if (typeof onChange === 'function') {
      onChange(key);
    }
  };

  const resolvePlaceholder = option => {
    if (option?.key === 'default') return 'DF';
    if (option?.key === 'none') return 'Ø';
    return option?.label?.charAt(0) ?? '?';
  };

  return (
    <div className={`flex flex-col gap-02 ${className}`}>
      {title && (
        <div className='text-3xs uppercase text-contrast text-opacity-60 tracking-wide'>
          {title}
        </div>
      )}
      <div
        className='flex flex-col gap-02 max-w-xs overflow-y-auto pr-02'
        style={{ maxHeight }}
      >
        {options.map(option => {
          const isActive = value === option.key;
          const previewIcon =
            option?.iconSlug && size > 6
              ? renderIconBySlug(option.iconSlug, {
                  size: size - 6,
                  color: 'var(--contrast)',
                })
              : null;
          const placeholder = resolvePlaceholder(option);
          return (
            <div
              key={option.key}
              className={`flex items-center gap-02 px-03 py-02 rounded cursor-pointer transition ${
                isActive
                  ? 'bg-primary bg-opacity-30 text-secondary'
                  : 'text-contrast text-opacity-80'
              }`}
              onClick={event => {
                event.stopPropagation();
                handleSelect(option.key);
              }}
            >
              <div
                className='rounded border border-primary border-opacity-20 flex items-center justify-center overflow-hidden bg-main bg-opacity-30'
                style={{ width: size, height: size }}
              >
                {option?.previewUrl ? (
                  <div
                    className='w-full h-full'
                    style={{
                      backgroundImage: `url(${option.previewUrl})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  />
                ) : previewIcon ? (
                  <span className='text-contrast text-opacity-90'>
                    {previewIcon}
                  </span>
                ) : (
                  <span className='text-3xs font-bold'>{placeholder}</span>
                )}
              </div>
              <span className='text-xs'>{option.label}</span>
            </div>
          );
        })}
      </div>
      {extra && <div className='pt-02'>{extra}</div>}
    </div>
  );
};
